var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{directives:[{name:"has-role",rawName:"v-has-role",value:(['manager','analyzer','saler','auditor','customer']),expression:"['manager','analyzer','saler','auditor','customer']"}],staticClass:"quitButton",attrs:{"size":"small"},on:{"click":_vm.quitProject}},[_vm._v(_vm._s(_vm.quitMessage)+" "),_c('i',{staticClass:"el-icon-refresh-left"})])
}
var staticRenderFns = []

export { render, staticRenderFns }